/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

// TODO: get rid of config file?
export abstract class UscConfig {
  mainScriptUrl?: string
  cookiePolicyBaseUrl?: string
  enableForLocalhost?: boolean
  itpScriptUrl?: string
  useItpBridge?: boolean
}

export const USC_DEFAULT_CONFIG: UscConfig = {
  mainScriptUrl: 'https://www.porsche.com/redesign-scripts/vendor/udg-uc-sdk.min.js',
  cookiePolicyBaseUrl: 'https://connect-store2.porsche.com',
  enableForLocalhost: false,
  itpScriptUrl: 'https://cookie.porsche.com/?settingsId={settingsId}',
  useItpBridge: false,
}
